import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShapeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Shape key / morph target icon - two overlapping shapes */}
      {/* Base shape */}
      <path
        d="M4 8l4-4h8l4 4v8l-4 4H8l-4-4V8z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Inner transformed shape */}
      <path
        d="M8 10l2-2h4l2 2v4l-2 2h-4l-2-2v-4z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill={color}
        fillOpacity="0.3"
      />
    </BaseIcon>
  ),
);

ShapeIcon.displayName = 'ShapeIcon';
